import React, { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import TextArea from '../fields/textArea';
import PrimaryButton from '../button/primaryButton';

const ImagePreviewer = ({
    openDoc,
    handleCloseDoc,
    imageAttachURL,
    notesMessage = '',
    isNoteEdit = false,
    onClick,
    buttonLoading,
    setDiscussionVal,
}) => {

    // Loading effect for the images
    const [isLoadingImg, setIsLoadingImg] = useState(true);

    const handleImageLoaded = () => {
        setIsLoadingImg(false);
    };

    const handleImageError = () => {
        console.error('Failed to load the image.');
        setIsLoadingImg(false);
    };

    // Zoom functionality for the images
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragging, setDragging] = useState(false);

    // Function to handle the change in range input
    const handleZoomChange = (event) => {
        setScale(event.target.value);
    };

    // Start dragging
    const handleDragStart = (event) => {
        event.preventDefault();
        setDragging(true);
        // setPosition({
        //     ...position, // Keep the previous position
        //     startX: event.clientX - position.x, // Calculate initial start position
        //     startY: event.clientY - position.y,
        // });

        const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
        const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

        setPosition({
            ...position,
            startX: clientX - position.x,
            startY: clientY - position.y,
        });

    };

    // Handle dragging
    const handleDragging = (event) => {
        if (dragging) {
            // setPosition({
            //     ...position,
            //     x: event.clientX - position.startX,
            //     y: event.clientY - position.startY,
            // });
            const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
            const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

            setPosition({
                ...position,
                x: clientX - position.startX,
                y: clientY - position.startY,
            });
        }
    };

    // Stop dragging
    const handleDragEnd = () => {
        setDragging(false);
    };

    // Reset image
    const handleResetImage = () => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    }
    return (
        <>

            <Modal show={openDoc} onHide={handleCloseDoc} centered style={{ background: '#fff0', border: 'none', }}>

                <div className='image-preview-modal-header'>

                    <a download href={imageAttachURL} target="_blank" rel="noreferrer">
                        <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                    </a>

                    <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                        <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                    </div>

                </div>

                {/* <>
            <img src={imageAttachURL} alt='Error Loading' style={{ width: '100%', height: '100%' }} />
        </> */}

                <div
                    className="col-12 px-0"
                    style={{ background: "#AAAAAA", position: "relative", minHeight: '300px' }}
                >
                    {isLoadingImg &&
                        <div
                            className='w-100 h-100 d-flex justify-content-center align-items-center overflow-hidden'
                            style={{
                                // maxWidth: `${imgMaxWidth}px`,
                                // maxHeight: `${imgMaxHeight}px`,
                                // minWidth: `${imgMaxWidth}px`,
                                // minHeight: `${imgMaxHeight}px`,
                                maxWidth: `100%`,
                                maxHeight: `70dvh`,
                                minWidth: `100%`,
                                minHeight: `300px`,
                                width: "100%",
                                height: "100%",
                            }}
                        >
                            <Spinner animation="border" size="lg" style={{}} />
                        </div>
                    }

                    <div
                        className='w-100 h-100 d-flex justify-content-center align-items-center overflow-hidden'
                        style={{ cursor: dragging ? 'grabbing' : 'grab' }}
                        onMouseMove={handleDragging}
                        onMouseLeave={handleDragEnd}
                        onMouseUp={handleDragEnd}
                        onTouchMove={handleDragging}
                        onTouchEnd={handleDragEnd}
                    >
                        <img
                            alt=""
                            className=""
                            src={imageAttachURL}
                            onLoad={handleImageLoaded}
                            onError={handleImageError}
                            onMouseDown={handleDragStart}
                            onTouchStart={handleDragStart}
                            style={{
                                // maxWidth: `${imgMaxWidth}px`,
                                // maxHeight: `${imgMaxHeight}px`,
                                // minWidth: `${imgMaxWidth}px`,
                                // minHeight: `${imgMaxHeight}px`,

                                maxWidth: `100%`,
                                maxHeight: `60dvh`,
                                minWidth: `100%`,
                                minHeight: `100%`,
                                width: "100%",
                                height: "100%",

                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                transition: 'transform 0.25s ease',
                                transformOrigin: 'center',
                                transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                                cursor: dragging ? 'grabbing' : 'grab',
                                display: isLoadingImg ? 'none' : 'block'
                            }}
                        />
                    </div>


                    {!isLoadingImg &&
                        <div
                            className="w-100 bg-white border-bottom"
                            style={{ position: "absolute", bottom: "0px", left: "0px" }}
                        >
                            <div className="align-items-center border-2 border-bottom border-white d-flex justify-content-center">
                                <span className="fs-6 font-w600 pe-2">{`Zoom`}</span>
                                <input
                                    className=""
                                    type="range"
                                    min="1"
                                    max="3"
                                    value={scale}
                                    step="0.1"
                                    onChange={handleZoomChange}
                                    style={{
                                        width: '75%',
                                        margin: '15px 0',
                                        cursor: 'pointer',
                                        background: 'linear-gradient(to right, #ddd 0%, #ddd 100%)',
                                        borderRadius: '5px',
                                        height: '4px',
                                        outline: 'none',
                                        opacity: '0.7',
                                        transition: 'opacity 0.2s',
                                    }}
                                />
                                {(scale !== 1 || position.x !== 0 || position.y !== 0) &&
                                    <div className=' ms-2'>
                                        <div className="tooltipCustom">
                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Reset photo"}</span>
                                            <i
                                                class="bi bi-arrow-clockwise fs-4 text-black text-hovered cursor-pointer"
                                                onClick={() => {
                                                    handleResetImage();
                                                }}
                                            ></i>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                </div>




                {isNoteEdit ?
                    <>
                        <div className="row mx-0">
                            <div className="col-12 p-3">

                                <div className='row mx-0'>
                                    <div className='col-12 pt-1'>


                                        <TextArea
                                            labelName={"Note"}
                                            placeholder={"Note"}
                                            value={notesMessage}
                                            onChange={(e) => setDiscussionVal(e.target.value)}
                                            onBlur={() => { }}
                                            rows='2'
                                        />
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div
                                        className='col-12'
                                        style={{
                                            pointerEvents: (notesMessage !== "") ? 'auto' : 'none',
                                            opacity: (notesMessage !== "") ? '1' : '0.5',
                                        }}
                                    >

                                        <PrimaryButton
                                            buttonName={`SAVE`}
                                            onClick={onClick}
                                            loadingMessage={"SAVING..."}
                                            isLoading={buttonLoading}
                                            style={{
                                                width: '100%',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </> :
                    <>
                        {notesMessage &&
                            <div className="row mx-0">
                                <div className="col-12 d-flex justify-content-center align-items-center p-3">
                                    <span className="text-center font-w600 text-black">{notesMessage}</span>
                                </div>
                            </div>
                        }
                    </>

                }


            </Modal>
        </>

    )
}

export default ImagePreviewer